import React, { Component } from 'react';

//componentes
import PlanillaP from './planillap'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanillaP />
            </div>
        );
    }

}
export default Index;